import {
  FUND_INVESTMENTS_COMPANIES_TITLE,
  FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR,
  FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE,
  FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE_SINGULAR,
} from 'pages/FundInvestments/common/constants';
import { GetMeasurementDateEntityNameParams, GetMeasurementDateInfoParams } from './CompaniesTable.types';

export const MOST_RECENT_DATE = 'Most Recent Date';

const pluralize = (count: number, singular: string, plural: string): string =>
  count === 1 ? singular : plural;

export const getMeasurementDateEntityName = (params: GetMeasurementDateEntityNameParams): string => {
  const { areFundInvestmentsEnabled, companyCount } = params;

  if (companyCount === 1) {
    return areFundInvestmentsEnabled
      ? FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE_SINGULAR
      : FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR;
  }

  return areFundInvestmentsEnabled
    ? FUND_INVESTMENTS_INDEXES_ETFS_COMPANIES_TITLE
    : FUND_INVESTMENTS_COMPANIES_TITLE;
};

export const getMeasurementDateInfo = (params: GetMeasurementDateInfoParams): string => {
  const { areFundInvestmentsEnabled = false, companyCount, fundCount } = params;

  const fundLabel = pluralize(fundCount, 'fund', 'funds');
  const companyLabel = getMeasurementDateEntityName({
    areFundInvestmentsEnabled,
    companyCount,
  }).toLowerCase();

  return `You are creating a measurement date for ${fundCount} ${fundLabel} and ${companyCount} ${companyLabel}. By default, Scalar copies the valuation (as a draft), related cap tables, financials, notes, and referenced documents, and sets public market data to the new measurement date. Use the table below to customize rollover options per company.`;
};

export const getMeasurementDateMismatchMessage = (areFundInvestmentsEnabled: boolean): string =>
  `One or more ${getMeasurementDateEntityName({
    areFundInvestmentsEnabled,
    companyCount: 2,
  }).toLowerCase()} did not have a source date matching the default source date`;
